import { render } from "./Play.vue?vue&type=template&id=4015ee48&scoped=true"
import script from "./Play.vue?vue&type=script&lang=js"
export * from "./Play.vue?vue&type=script&lang=js"

import "./Play.vue?vue&type=style&index=0&id=4015ee48&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4015ee48"]])

export default __exports__